"use client";

import { useLocale, useTranslations } from "next-intl";
import { useCallback, useEffect, useState } from "react";


export interface NavLink {
  key: string;
  label: string;
  href: string;
}

export function useHeader() {
  const t = useTranslations("nav");
  const locale = useLocale();
  const isRTL = locale === "ar";

  const [isScrolled, setIsScrolled] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  // ── Scroll ──
  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // ── Close on desktop resize ──
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024) setIsMobileMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // ── Lock body scroll ──
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileMenuOpen]);

  const navLinks: NavLink[] = [
    {
      key: "explore",
      label: isRTL ? "استكشف" : "Explore",
      href: `/${locale}/explore`,
    },
    {
      key: "help",
      label: isRTL ? "المساعدة" : "Help",
      href: `/${locale}/help`,
    },
  ];

  const toggleMobileMenu = useCallback(
    () => setIsMobileMenuOpen((p) => !p),
    [],
  );
  const closeMobileMenu = useCallback(() => setIsMobileMenuOpen(false), []);

  const openLoginModal = useCallback(() => setIsLoginModalOpen(true), []);
  const closeLoginModal = useCallback(() => setIsLoginModalOpen(false), []);

  return {
    isScrolled,
    isMobileMenuOpen,
    isLoginModalOpen,
    navLinks,
    locale,
    isRTL,
    listLabel: t("listProperty"),
    loginLabel: t("login"),
    toggleMobileMenu,
    closeMobileMenu,
    openLoginModal,
    closeLoginModal,
  };
}
